import { render } from "./FeatureSingle.vue?vue&type=template&id=0ea63889"
import script from "./FeatureSingle.vue?vue&type=script&lang=js"
export * from "./FeatureSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/FeatureHighlight/FeatureSingle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ea63889"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ea63889', __exports__)) {
    api.reload('0ea63889', __exports__)
  }
  
  module.hot.accept("./FeatureSingle.vue?vue&type=template&id=0ea63889", () => {
    api.rerender('0ea63889', render)
  })

}


export default __exports__